module.exports = __webpack_public_path__ + "img/Wechat.f9415cc4.jpg";